import { render } from "./EmptyBlock.vue?vue&type=template&id=9aa50bb0&scoped=true"
const script = {}

import "./EmptyBlock.vue?vue&type=style&index=0&id=9aa50bb0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa50bb0"]])

export default __exports__